// extracted by mini-css-extract-plugin
module.exports = {"container":"payout-report-page_container__Zcwyp","main-title":"payout-report-page_main-title__rww_8"};